import React from "react";
import { ReactComponent as Frame11 } from "../components/assests/career/frame-11.svg";
import { ReactComponent as Frame48095965 } from "../components/assests/career/frame-48095965.svg";
import { ReactComponent as Frame48095969 } from "../components/assests/career/frame-48095969.svg";
import { ReactComponent as Frame48095976 } from "../components/assests/career/frame-48095976.svg";
import { ReactComponent as Frame48095977 } from "../components/assests/career/frame-48095977.svg";
import { ReactComponent as Frame48095978 } from "../components/assests/career/frame-48095978-2.svg";
import { ReactComponent as Frame48096008 } from "../components/assests/career/frame-48096008.svg";
import { ReactComponent as IconComponentNode } from "../components/assests/career/frame-11.svg";
import { ReactComponent as Line24 } from "../components/assests/career/line-24.svg";
import { ReactComponent as Line26 } from "../components/assests/career/line-26.svg";
import { ReactComponent as Line40 } from "../components/assests/career/line-40.svg";
import { ReactComponent as Line91 } from "../components/assests/career/line-91.svg";
import { ReactComponent as NamecandidateNameFrame11Score101 } from "../components/assests/career/frame-11.svg";
import { ReactComponent as NamecandidateNameFrame11Score102 } from "../components/assests/career/frame-11.svg";
import { ReactComponent as NamecandidateNameFrame11Score103 } from "../components/assests/career/frame-11.svg";
import AboutUs256017061 from "../components/assests/career/about-us-2560x1706-1.png";
import Group41225 from "../components/assests/career/group-41225.png";
import Image from "../components/assests/career/rectangle-1031.png";
import Rectangle1028 from "../components/assests/career/rectangle-1028.png";
import Rectangle10292 from "../components/assests/career/rectangle-1029-1.png";
import Rectangle10302 from "../components/assests/career/rectangle-1030-1.png";
import Rectangle1031 from "../components/assests/career/rectangle-1031.png";
import Rectangle10282 from "../components/assests/career/rectangle-1028-1.png";
import Rectangle1029 from "../components/assests/career/rectangle-1029.png";
import Rectangle1030 from "../components/assests/career/rectangle-1030.png";
import Group41210 from "../components/assests/career/group-41210.png";


import "./style.css";

export const Career = () => {
  return (
    <div className="career">
      <div className="div">
        <div className="overlap">
          <img className="line" alt="Line" />
          <Frame48095969 className="frame" color="#EEFFF6" />
          <Frame48095969 className="frame" color="#EEFFF6" />
          <Frame48095969 className="frame" color="#EEFFF6" />
          <Frame48095969 className="frame" color="#EEFFF6" />
          <Frame48095969 className="frame" color="#EEFFF6" />
          <Frame48095969 className="frame" color="#EEFFF6" />
          <Frame48095969 className="frame" color="#EEFFF6" />
          <Frame48095969 className="frame" color="#007367" />
          <Frame48095969 className="frame" color="#007367" />
          <Frame48095969 className="frame" color="#007367" />
          <Frame48095969 className="frame" color="#007367" />
          <Frame48095969 className="frame" color="#007367" />
          <Frame48095969 className="frame" color="#007367" />
          <Frame48095969 className="frame" color="#007367" />
        </div>
        <div className="overlap-group">
          <div className="overlap-2">
            <div className="overlap-3">
              <div className="rectangle" />
              <div className="group">
                <div className="frame-2">
                  <div className="heading-example-wrapper">
                    <p className="heading-example">
                      La diversité des profils au sein de notre équipe constitue un atout essentiel qui nous permet de
                      concevoir et mettre en œuvre des stratégies robustes. Nous gérons l&#39;intégralité de la chaîne
                      de valeur de l&#39;investissement immobilier, depuis la structuration des fonds jusqu&#39;à la
                      gestion des biens présents au sein de nos portefeuilles.
                    </p>
                  </div>
                  <p className="text-wrapper">
                    En optant pour une carrière chez Beatimo, tu intègres une équipe déterminée à contribuer au succès
                    des entreprises régionales. Ton engagement a un impact concret sur leur développement, en exploitant
                    pleinement ton potentiel. Rejoindre Beatimo, c&#39;est non seulement être partie prenante des
                    réussites locales, mais aussi participer activement à l&#39;épanouissement et à la croissance des
                    entreprises régionales.
                  </p>
                </div>
                <div className="frame-wrapper">
                  <div className="comp-tences-vari-es-wrapper">
                    <p className="comp-tences-vari-es">
                      <span className="span">Compétences </span>
                      <span className="text-wrapper-2">
                        variées dans <br />
                        le domaine de{" "}
                      </span>
                      <span className="span">l&#39;investissement </span>
                      <span className="text-wrapper-2">immobilier</span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="frame-3">
                <div className="joignez-vous-notre-wrapper">
                  <p className="joignez-vous-notre">
                    <span className="text-wrapper-3">
                      Joignez-vous à<br />
                      notre{" "}
                    </span>
                    <span className="text-wrapper-4">équipe </span>
                  </p>
                </div>
                <div className="frame-4">
                  <div className="div-wrapper">
                    <div className="frame-5">
                      <div className="text-wrapper-5">VOIR LES OPPORTUNITÉS</div>
                    </div>
                  </div>
                  <Frame11 className="frame-11" />
                </div>
              </div>
              <div className="rectangle-2" />
              <img className="about-us" alt="About us" src={AboutUs256017061} />
              <div className="frame-6">
                <Frame48095965 className="icon-instance-node" />
                <div className="frame-7">
                  <div className="navbar">
                    <div className="text-wrapper-6">SERVICES</div>
                    <div className="text-wrapper-6">À PROPOS</div>
                    <div className="text-wrapper-6">CARRIÈRE</div>
                    <div className="text-wrapper-6">RÉSEAUX SOCIAUX</div>
                    <div className="text-wrapper-6">EN</div>
                  </div>
                  <img className="img" alt="Group" src={Group41225} />
                </div>
              </div>
              <div className="group-wrapper">
                <div className="group-2">
                  <div className="frame-8">
                  <img className="rectangle-3" alt="Rectangle" src={Image} />
                    <img className="rectangle-4" alt="Rectangle" src={Rectangle1028} />
                    <img className="rectangle-5" alt="Rectangle" src={Rectangle10292} />
                    <img className="rectangle-6" alt="Rectangle" src={Rectangle10302} />

                  </div>
                  <div className="frame-9">
                  <img className="rectangle-7" alt="Rectangle" src={Rectangle1031} />
                    <img className="rectangle-8" alt="Rectangle" src={Rectangle10282} />
                    <img className="rectangle-7" alt="Rectangle" src={Rectangle1029} />
                    <img className="rectangle-8" alt="Rectangle" src={Rectangle1030} />

                  </div>
                </div>
              </div>
              <div className="group-3">
                <div className="group-4">
                  <div className="frame-10">
                    <div className="frame-12">
                      <div className="heading-example-2">Collaboration</div>
                    </div>
                    <div className="frame-12">
                      <p className="p">
                        L&#39;entreprise favorise un environnement de travail collaboratif où les employés peuvent
                        travailler en équipe pour atteindre des objectifs communs et partager leurs connaissances.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="group-5">
              <div className="group-6">
                <div className="frame-10">
                  <div className="frame-12">
                    <div className="heading-example-2">Flexibilité</div>
                  </div>
                  <div className="frame-12">
                    <p className="p">
                      Beatimo offre une flexibilité au niveau des horaires de travail et du lieu de travail, ce qui
                      permet aux employés d&#39;équilibrer plus facilement leur vie.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="group-7">
            <div className="group-6">
              <div className="frame-10">
                <div className="frame-12">
                  <div className="heading-example-2">Innovation</div>
                </div>
                <div className="frame-12">
                  <p className="p">
                    Beatimo encourage l&#39;innovation, permettant aux employés de proposer et de mettre en œuvre de
                    nouvelles idées pour améliorer les produits et les processus.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="group-8">
          <div className="group-4">
            <div className="frame-10">
              <div className="frame-12">
                <div className="heading-example-2">Culture</div>
              </div>
              <div className="frame-12">
                <p className="p">
                  Beatimo promeut une culture d&#39;entreprise positive, axée sur le bien-être des employés, la
                  diversité et l&#39;inclusion, créant ainsi un environnement de travail stimulant et gratifiant.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="overlap-4">
          <div className="rectangle-9" />
          <div className="frame-13">
            <div className="frame-14">
              <div className="group-9">
                <div className="frame-15">
                  <IconComponentNode className="vector-instance" color="#EEFFF6" />
                  <div className="heading-example-3">NOS POSTES DISPONIBLES</div>
                </div>
              </div>
              <div className="frame-16">
                <p className="explorez-les">
                  <span className="text-wrapper-7">Explorez les </span>
                  <span className="span">opportunités </span>
                  <span className="text-wrapper-7">disponibles chez nous.</span>
                </p>
                <div className="frame-4">
                  <div className="div-wrapper">
                    <div className="frame-5">
                      <div className="text-wrapper-5">CANDIDATURE SPONTANNÉE</div>
                    </div>
                  </div>
                  <NamecandidateNameFrame11Score101 className="frame-11" />
                </div>
              </div>
            </div>
          </div>
          <div className="frame-17">
            <Line40 className="line-40" />
            <div className="frame-18">
              <div className="frame-19">
                <div className="group-10">
                  <div className="frame-15">
                    <IconComponentNode className="vector-instance" color="#EEFFF6" />
                    <div className="heading-example-3">TEMPS PLEIN - MONTRÉAL</div>
                  </div>
                </div>
                <div className="text-wrapper-8">Analyste financier immobilier</div>
              </div>
              <Frame48096008 className="icon-instance-node" />
            </div>
            <Line40 className="line-35" />
            <div className="frame-18">
              <div className="frame-19">
                <div className="group-10">
                  <div className="frame-15">
                    <IconComponentNode className="vector-instance" color="#EEFFF6" />
                    <div className="heading-example-3">TEMPS PLEIN - MONTRÉAL</div>
                  </div>
                </div>
                <div className="text-wrapper-8">Conseiller en investissement immobilier</div>
              </div>
              <Frame48096008 className="icon-instance-node" />
            </div>
            <Line40 className="line-35" />
            <div className="frame-18">
              <div className="frame-19">
                <div className="group-11">
                  <div className="frame-15">
                    <IconComponentNode className="vector-instance" color="#EEFFF6" />
                    <div className="heading-example-3">TEMPS PLEIN - QUÉBEC</div>
                  </div>
                </div>
                <div className="text-wrapper-8">Agent immobilier commercial</div>
              </div>
              <Frame48096008 className="icon-instance-node" />
            </div>
            <Line40 className="line-35" />
            <div className="frame-20">
              <div className="frame-21">
                <div className="group-11">
                  <div className="frame-15">
                    <IconComponentNode className="vector-instance" color="#EEFFF6" />
                    <div className="heading-example-3">TEMPS PLEIN - QUÉBEC</div>
                  </div>
                </div>
                <div className="text-wrapper-9">Gestionnaire de portefeuille immobilier</div>
              </div>
              <Frame48096008 className="icon-instance-node" />
            </div>
            <Line40 className="line-35" />
            <div className="frame-20">
              <div className="frame-21">
                <div className="group-11">
                  <div className="frame-15">
                    <IconComponentNode className="vector-instance" color="#EEFFF6" />
                    <div className="heading-example-3">TEMPS PLEIN - QUÉBEC</div>
                  </div>
                </div>
                <div className="text-wrapper-9">Expert en évaluation immobilière</div>
              </div>
              <Frame48096008 className="icon-instance-node" />
            </div>
            <Line40 className="line-35" />
            <div className="frame-20">
              <div className="frame-21">
                <div className="group-11">
                  <div className="frame-15">
                    <IconComponentNode className="vector-instance" color="#EEFFF6" />
                    <div className="heading-example-3">TEMPS PLEIN - QUÉBEC</div>
                  </div>
                </div>
                <div className="text-wrapper-9">Chargé de recherche immobilière</div>
              </div>
              <Frame48096008 className="icon-instance-node" />
            </div>
            <Line40 className="line-35" />
          </div>
          <Line91 className="line-91" />
          <div className="group-12">
            <div className="group-13">
              <Line24 className="line-24" />
              <div className="frame-22">
                <div className="frame-23">
                  <p className="text-wrapper-10">COPYRIGHT © 2024 BEATIMO | TOUT DROITS RÉSERVÉS</p>
                  <div className="text-wrapper-10">PRÉFÉRENCE DES TÉMOINS</div>
                  <div className="text-wrapper-10">POLITIQUES ET CONFIDENTIALITÉ</div>
                </div>
                <p className="site-par-les-mauvais">SITE PAR LES MAUVAIS GARÇONS</p>
              </div>
              <img className="group-14" alt="Group" src={Group41210} />
              <div className="group-15">
                <Line26 className="line-26" />
                <Line26 className="line-25" />
                <Line26 className="line-30" />
                <div className="overlap-5">
                  <div className="text-wrapper-11">01</div>
                  <div className="text-wrapper-12">Facebook</div>
                </div>
                <div className="overlap-6">
                  <div className="text-wrapper-13">03</div>
                  <div className="text-wrapper-14">LinkedIn</div>
                </div>
                <Line26 className="line-29" />
                <div className="overlap-group-2">
                  <div className="text-wrapper-15">02</div>
                  <div className="text-wrapper-14">Youtube</div>
                </div>
                <div className="overlap-7">
                  <div className="text-wrapper-15">04</div>
                  <div className="text-wrapper-14">Tiktok</div>
                </div>
                <div className="group-16">
                  <div className="frame-15">
                    <IconComponentNode className="vector-instance" color="#FFFAE6" />
                    <div className="heading-example-4">NOS RÉSEAUX SOCIAUX</div>
                  </div>
                </div>
                <Frame48095976 className="frame-48095976" />
                <Frame48095977 className="frame-48095977" />
                <Frame48095978 className="frame-48095978" />
                <NamecandidateNameFrame11Score102 className="frame-11-instance" />
              </div>
            </div>
          </div>
          <div className="rectangle-10" />
          <div className="frame-24">
            <div className="frame-25">
              <div className="frame-26">
                <IconComponentNode className="vector-instance" color="#EEFFF6" />
                <div className="heading-example-3">À PROPOS</div>
              </div>
              <p className="heading">
                <span className="span">Curieux </span>
                <span className="text-wrapper-2">de découvrir qui nous </span>
                <span className="span">sommes </span>
                <span className="text-wrapper-2">et de ce que nous </span>
                <span className="span">représentons?</span>
              </p>
            </div>
            <div className="frame-27">
              <div className="frame-4">
                <div className="frame-28">
                  <div className="frame-5">
                    <div className="text-wrapper-5">DÉCOUVRIR BEATIMO</div>
                  </div>
                </div>
                <NamecandidateNameFrame11Score103 className="frame-11" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Career;